import { registerArchetype } from './index.js';
import { getRuntimes } from '../combat.js';
registerArchetype({
    id: 'ult_charge_boost',
    apply: ({ state, source, params }) => {
        const amount = params.amount ?? 0.2;
        const r = getRuntimes(state, source.side)[source.slot];
        r.statuses.push({
            id: `ult_charge_boost_${source.slot}`,
            kind: 'buff',
            remainingTicks: Number.MAX_SAFE_INTEGER,
            params: { ultChargePct: amount }
        });
    }
});
